/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Community_LinksInputs */



/**
* | output |
* | --- |
* | "Community Links" |
*
* @param {Profile_Community_LinksInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_community_links = /** @type {((inputs?: Profile_Community_LinksInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Community_LinksInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liens communautaires")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enlaces de comunidad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Links da comunidade")
	if (locale === "it") return /** @type {LocalizedString} */ ("Link della comunità")
	return /** @type {LocalizedString} */ ("Community Links")
});